import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="ticket-filters"
export default class extends Controller {
  static targets = ["asyncDropdown"];

  connect() {
    this.loadedDropdowns = new Set();

    this.element.querySelectorAll("select").forEach((select) => {
      if (!select.hasAttribute("data-ticket-filters-target")) {
        select.addEventListener("change", this.handleSelectChange.bind(this));
      }
    });

    this.asyncDropdownTargets.forEach((dropdown) => {
      // Only add async loading listeners if dropdown doesn't have server-side options
      const hasServerSideOptions = dropdown.querySelectorAll("option").length > 2;

      if (!hasServerSideOptions) {
        dropdown.addEventListener("click", this.handleAsyncDropdownClick.bind(this));
        dropdown.addEventListener("focus", this.handleAsyncDropdownClick.bind(this));
      }

      dropdown.addEventListener("change", this.handleSelectChange.bind(this));
    });

    this.loadPreselecteddropdowns();
  }

  asyncDropdownTargetConnected(dropdown) {}

  handleSelectChange(event) {
    const select = event.target;
    const currentUrl = new URL(window.location);
    const currentValue = currentUrl.searchParams.get(select.name) || "";

    // Only submit if the value actually changed
    if (select.value !== currentValue) {
      this.element.submit();
    }
  }

  handleAsyncDropdownClick(event) {
    const dropdown = event.target;
    const dropdownType = dropdown.dataset.dropdownType;

    // Guard: Don't proceed if dropdown doesn't have a dropdownType
    if (!dropdownType) {
      return;
    }

    // Check if dropdown already has loaded options (more than just placeholder and loading)
    const hasLoadedOptions = dropdown.querySelectorAll("option").length > 2;

    if (!this.loadedDropdowns.has(dropdownType) && !hasLoadedOptions) {
      const loadingOption = dropdown.querySelector("option[disabled]");
      this.loadDropdown(dropdown, dropdownType);
    }
  }

  loadPreselecteddropdowns() {
    const urlParams = new URLSearchParams(window.location.search);

    this.asyncDropdownTargets.forEach((dropdown) => {
      const dropdownType = dropdown.dataset.dropdownType;

      // Guard: Skip dropdowns without dropdownType
      if (!dropdownType) {
        return;
      }

      const paramName = dropdown.name;
      const hasLoadedOptions = dropdown.querySelectorAll("option").length > 2;

      // If dropdown already has server-side rendered options, mark it as loaded
      if (hasLoadedOptions) {
        this.loadedDropdowns.add(dropdownType);
      }

      // Only load if there's a parameter value and dropdown isn't already server-side rendered
      if (urlParams.has(paramName) && urlParams.get(paramName) && !hasLoadedOptions) {
        this.loadDropdown(dropdown, dropdownType);
      }
    });
  }

  async loadDropdown(dropdown, dropdownType) {
    if (this.loadedDropdowns.has(dropdownType) || dropdown.dataset.loading === "true") {
      return;
    }

    dropdown.dataset.loading = "true";
    this.loadedDropdowns.add(dropdownType);

    try {
      const urlParams = new URLSearchParams(window.location.search);
      const url = `/admin/tickets/dropdown?${urlParams.toString()}&dropdown_type=${dropdownType}`;

      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();

      dropdown.innerHTML = "";

      data.options.forEach((option) => {
        const optionElement = document.createElement("option");
        optionElement.value = option.value;
        optionElement.textContent = option.text;
        if (option.selected) {
          optionElement.selected = true;
        }
        dropdown.appendChild(optionElement);
      });
    } catch (error) {
      console.error("Error loading dropdown:", error);

      dropdown.innerHTML = `<option value="">Failed to load ${dropdownType.replace(/_/g, " ")}</option>`;
      dropdown.dataset.loading = "false";
      this.loadedDropdowns.delete(dropdownType);
    }
  }
}
